class BundleTiers extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('product-info') || document;
    this.radios = Array.from(this.querySelectorAll('.bundle-tier__radio'));

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.select(radio));
    });

    const checked = this.radios.find((radio) => radio.checked && !radio.disabled);
    if (checked) {
      this.select(checked);
    } else {
      this.lockQuantity(true);
    }
  }

  lockQuantity(locked) {
    const quantity = this.scope.querySelector('.product-form__quantity');
    if (!quantity) return;

    quantity.classList.toggle('product-form__quantity--locked', locked);
    quantity.querySelectorAll('input, button').forEach((element) => {
      element.disabled = locked;
    });
  }

  select(radio) {
    this.radios.forEach((item) => {
      item.closest('.bundle-tier').classList.toggle('bundle-tier--selected', item === radio);
    });

    const variantInput = this.scope.querySelector('input.product-variant-id');
    if (variantInput) {
      variantInput.value = radio.dataset.variantId;
      variantInput.disabled = false;
    }

    const submitButton = this.scope.querySelector('.product-form__submit');
    if (submitButton) {
      submitButton.disabled = false;
      const label = submitButton.querySelector('span');
      if (label) label.textContent = this.dataset.addToCartText;
    }

    this.lockQuantity(false);
  }
}

if (!customElements.get('bundle-tiers')) {
  customElements.define('bundle-tiers', BundleTiers);
}
